import {parseNumber} from '@benchling/js-utils';

import {RowCountDetails} from './RowCountDetails';

/**
 * Parse a string value into a row count.
 * @param stringValue Text that was entered as a row count
 * @param minRowCount Minimum row count
 * @param maxRowCount Maximum row count
 * @returns The parsed row count, the original text, and whether the text was a valid row count.
 */
export default function parseRowCount(
  stringValue: string,
  minRowCount: number,
  maxRowCount: number
): RowCountDetails {
  const invalidRowCountDetails: RowCountDetails = {
    rowCountText: stringValue,
    isValid: false,
    rowCount: null,
  };
  if (!stringValue) {
    return invalidRowCountDetails;
  }
  const numericValue = parseNumber(stringValue);
  if (numericValue == null) {
    return invalidRowCountDetails;
  }
  if (numericValue < minRowCount || numericValue > maxRowCount) {
    return invalidRowCountDetails;
  }
  if (!Number.isInteger(numericValue)) {
    return invalidRowCountDetails;
  }
  return {
    rowCountText: stringValue,
    isValid: true,
    rowCount: numericValue,
  };
}
